import {
  HeatMapDateRangeOption,
  DEFAULT_DATE_RANGE_OPTION,
  DEFAULT_HIGH_COLOR,
  DEFAULT_LOW_COLOR,
} from "../../utils/HeatMapUtils";

export const SET_HEATMAP_METRIC = "SET_HEATMAP_METRIC";
export const SET_HEATMAP_DATE_RANGE = "SET_HEATMAP_DATE_RANGE";
export const SET_HEATMAP_HIGH_COLOR = "SET_HEATMAP_HIGH_COLOR";
export const SET_HEATMAP_LOW_COLOR = "SET_HEATMAP_LOW_COLOR";
export const SET_DISPLAY_GRADIENT_ON_GRID = "SET_DISPLAY_GRADIENT_ON_GRID";
export const RESET_HEATMAP_STATE = "RESET_HEATMAP_STATE";

/** Default metric per spec: Inventory selected by default. */
export const DEFAULT_HEATMAP_METRIC = "Inventory";

export interface HeatMapDateRangeState {
  option: HeatMapDateRangeOption;
  /** Custom start date (only used when option = SPECIFIC_DATE or DATE_RANGE). */
  customStartDate?: string;
  /** Custom end date (only used when option = DATE_RANGE). */
  customEndDate?: string;
}

export interface HeatMapState {
  metric: string;
  dateRange: HeatMapDateRangeState;
  highColor: string;
  lowColor: string;
  pendingRequests: number;
  lastFetchedStartDate?: string;
  lastFetchedEndDate?: string;
  lastSettledRangeKey: string;
  freshProductCodes: Record<string, true>;
  displayGradientOnGrid: boolean;
}

export const initialHeatMapState: HeatMapState = {
  metric: DEFAULT_HEATMAP_METRIC,
  dateRange: {
    option: DEFAULT_DATE_RANGE_OPTION,
  },
  highColor: DEFAULT_HIGH_COLOR,
  lowColor: DEFAULT_LOW_COLOR,
  pendingRequests: 0,
  lastSettledRangeKey: "",
  freshProductCodes: {},
  displayGradientOnGrid: false,
};

export interface SetHeatMapMetricAction {
  type: typeof SET_HEATMAP_METRIC;
  payload: { metric: string };
}

export interface SetHeatMapDateRangeAction {
  type: typeof SET_HEATMAP_DATE_RANGE;
  payload: HeatMapDateRangeState;
}

export interface SetHeatMapHighColorAction {
  type: typeof SET_HEATMAP_HIGH_COLOR;
  payload: { color: string };
}

export interface SetHeatMapLowColorAction {
  type: typeof SET_HEATMAP_LOW_COLOR;
  payload: { color: string };
}

export interface SetDisplayGradientOnGridAction {
  type: typeof SET_DISPLAY_GRADIENT_ON_GRID;
  payload: { enabled: boolean };
}

export interface ResetHeatMapStateAction {
  type: typeof RESET_HEATMAP_STATE;
  payload?: { displayGradientOnGrid: boolean };
}

export type HeatMapAction =
  | SetHeatMapMetricAction
  | SetHeatMapDateRangeAction
  | SetHeatMapHighColorAction
  | SetHeatMapLowColorAction
  | SetDisplayGradientOnGridAction
  | ResetHeatMapStateAction;
